export enum EnterpriseStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
}
